import { put, takeEvery, select, call } from 'redux-saga/effects';
import {
  VIEWING_BURN_ANNOTATION_BEGIN,
  VIEWING_BURN_ANNOTATION_SUCCESS,
  VIEWING_BURN_ANNOTATION_FAILURE,
  VIEWING_BURN_ANNOTATION_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId, selectCurrentFile } from 'common/selectors';

export const burnAnnotation = createPromiseAction(VIEWING_BURN_ANNOTATION_BEGIN);

export function dismissBurnAnnotationFeedback() {
  return {
    type: VIEWING_BURN_ANNOTATION_DISMISS_FEEDBACK,
  };
}

// worker Saga: will be fired on VIEWING_BURN_ANNOTATION_BEGIN actions
export function* doBurnAnnotation(action) {
  const {
    payload: { mode, fileId, caseId },
  } = action;

  const file = yield select(selectCurrentFile);

  const res = yield call(api.post, `/cases/${caseId}/files/${file || fileId}/annotations/burn`);

  if (res && res.error) {
    yield put({
      type: VIEWING_BURN_ANNOTATION_FAILURE,
      feedback: {
        message: 'feedback.burnAnnotationFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: VIEWING_BURN_ANNOTATION_SUCCESS,
    feedback: {
      message:
        mode === 'burnSignature'
          ? 'feedback.burnAnnotationSuccess'
          : 'feedback.burnCrossRefSuccess',
      success: true,
    },
  });
  yield call(resolvePromiseAction, action, res);
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchBurnAnnotation() {
  yield takeEvery(burnAnnotation, withCurrentCaseId(doBurnAnnotation));
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case VIEWING_BURN_ANNOTATION_BEGIN + '.TRIGGER':
      return {
        ...state,
        burnAnnotationPending: true,
        burnAnnotationFeedback: null,
      };

    case VIEWING_BURN_ANNOTATION_SUCCESS:
      return {
        ...state,
        burnAnnotationPending: false,
        burnAnnotationFeedback: action.feedback,
      };

    case VIEWING_BURN_ANNOTATION_FAILURE:
      return {
        ...state,
        burnAnnotationPending: false,
        burnAnnotationFeedback: action.feedback,
      };

    case VIEWING_BURN_ANNOTATION_DISMISS_FEEDBACK:
      return {
        ...state,
        burnAnnotationFeedback: null,
      };

    default:
      return state;
  }
}
